<form [formGroup]="formGroup" (submit)="submit()">
    <div class="modal-header">
        <h5 class="modal-title">
            {{ 'titles_editResidentDetails' | translate: 'online' : 'residents' }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
    </div>

    <div class="modal-body">
        <div class="alert alert-warning" role="alert">
            {{ 'information_editResidentNameWarning' | translate: 'online' : 'residents' }}
        </div>

        <div class="row gy-3">
            <div class="col-lg-8">
                <label for="consumerNameInput">
                    {{ 'properties_residentName' | translate: 'online' : 'systems' }}
                </label>
                <app-input-text-group
                    id="consumerNameInput"
                    [trim]="true"
                    [maxLength]="100"
                    [formControl]="formGroup.controls.name"></app-input-text-group>
                <app-control-messages [control]="formGroup.controls.name"></app-control-messages>
            </div>

            <div class="col-lg-4">
                <label for="consumerNoInput">
                    {{ 'properties_consumerNo' | translate: 'online' : 'systems' }}
                </label>
                <app-input-text-group
                    id="consumerNoInput"
                    [trim]="true"
                    [maxLength]="20"
                    [formControl]="formGroup.controls.consumerNo"></app-input-text-group>
                <app-control-messages
                    [control]="formGroup.controls.consumerNo"></app-control-messages>
            </div>

            <div class="col-lg-12">
                <label for="consumerEmailInput">
                    {{ 'properties_email' | translate: 'online' : 'residents' }}
                </label>
                <app-input-text-group
                    id="consumerEmailInput"
                    [trim]="true"
                    [maxLength]="emailMaxLength"
                    [formControl]="formGroup.controls.email"></app-input-text-group>
                <app-control-messages [control]="formGroup.controls.email"></app-control-messages>
            </div>

            <div class="col-lg-4">
                <label for="countryCallingCodeInput">
                    {{ 'common_country_code' | translate }}
                </label>
                <app-input-dropdown-group
                    id="countryCallingCodeInput"
                    [data]="countryCallingCodes"
                    [formControl]="
                        formGroup.controls.countryCallingCode
                    "></app-input-dropdown-group>
            </div>

            <div class="col-lg-8">
                <label for="localNumberInput">
                    {{ 'common_PHONE' | translate: 'online' : 'common' }}
                </label>
                <app-input-text-group
                    id="localNumberInput"
                    [trim]="true"
                    [maxLength]="20"
                    [formControl]="formGroup.controls.localNumber"></app-input-text-group>
            </div>

            <div class="col-lg-12">
                <app-control-messages [control]="formGroup"></app-control-messages>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="dismiss()">
            {{ 'actions_cancel' | translate: 'online' : 'common' }}
        </button>
        <button type="submit" class="btn btn-primary">
            {{ 'actions_save' | translate: 'online' : 'common' }}
        </button>
    </div>
</form>
